export default __webpack_public_path__ + "static/media/STRYKER 125_3.c092f9ca.webp";